// extracted by mini-css-extract-plugin
module.exports = {"label":"Form_label__2rs3x","erg":"Form_erg__ggiKp"};